import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=13cae5b1"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=13cae5b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports